import 'regenerator-runtime/runtime';

const axios = require('axios');

const URL = 'https://ftn-scripts-staging.herokuapp.com/api/news';

const fetchSingleNews = async () => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  const id = urlSearchParams.get('id');

  const response = await axios.default.get(`${URL}/${id}`);

  const news = response.data.data;

  const [image] = news?.images ?? [];

  document.title = news?.title;

  document.querySelector(
    '#img-container'
  ).innerHTML = `<img class="img-responsive" src="${image?.url}">`;

  document.querySelector('.news-content .section-title').innerHTML =
    news?.title;
  document.querySelector('.news-content .section-text').innerHTML =
    news?.content?.replaceAll('\n', '<br>');
};

(async () => await fetchSingleNews().catch(console.error))();
